import { render, staticRenderFns } from "./WtMediaObject.vue?vue&type=template&id=1526631b&scoped=true&lang=pug&"
import script from "./WtMediaObject.vue?vue&type=script&lang=js&"
export * from "./WtMediaObject.vue?vue&type=script&lang=js&"
import style0 from "./WtMediaObject.vue?vue&type=style&index=0&id=1526631b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1526631b",
  null
  
)

export default component.exports